import { createFileRoute } from '@tanstack/react-router';
import CorrectiveActions from 'src/pages/Organization/Players/CorrectiveActions';

export const Route = createFileRoute(
  '/$organizationSlug/players/$playerId/corrective_actions',
)({
  component: CorrectiveActions,
});
